import {getUseSharedState} from '~/utils/getUseSharedState'

import type {ProfileCache} from '~/types/profile'

export const cache: ProfileCache = {
    profile: undefined,
}

export const changeDispatcher = getUseSharedState({})

export function invalidateCache({shouldDispatch}: {shouldDispatch?: boolean}) {
    cache.profile = undefined

    if (shouldDispatch)
        changeDispatcher.dispatch({})
}

